<template>
     <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'authenticationMemberList' }">
                        会员管理
                    </router-link>
                </li>
                <li class="active">会员详细信息</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form :model="cashModel" label-width="100px">
                <el-form-item label="时间：">
                    <el-input v-model="cashModel.createTime" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="提现用户：">
                    <el-input v-model="cashModel.nickname" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="金额：">
                    <el-input v-model="cashModel.money" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="手续费：">
                    <el-input v-model="cashModel.serviceFee" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="银行：">
                    <el-input v-model="cashModel.bankName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="卡号：">
                    <el-input v-model="cashModel.code" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="持卡人：">
                    <el-input v-model="cashModel.name" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="状态：">
                    <el-select v-model="cashModel.status" disabled>
                        <el-option v-for="item in statuses" :key="item.name" :label="item.label" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" @click="$router.back(-1)">取消</el-button>
                    <el-button :disabled="disabledCash" size="small" type="primary" v-if="cashModel.status =='APPLIED'" @click="updateBalanceExtractStatus('SUCCESS',cashModel.id)">审核通过</el-button>
                    <el-button :disabled="disabledCash" size="small" type="primary" v-if="cashModel.status =='APPLIED'" @click="openCheckDialog('REJECTED',cashModel.id)">审核拒绝</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-modal">
            <el-dialog title="提现审核" :visible.sync="dialogVisible" width="60%" center>
                <el-form ref="formName" :model="checkModel" :rules="rules" label-width="100px" style="width:80%;margin:0 auto;">
                    <el-form-item label="审核说明：">
                        <el-input type="textarea" :rows="2" v-model="checkModel.remark" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" :disabled="disabledCash" type="primary" @click="updateBalanceExtractStatus">提交</el-button>
                        <el-button size="small" @click="resetForm('formName')">重置</el-button>
                        <el-button size="small" @click="dialogVisible=false">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            cashId: '',
            cashModel: {
                
            },
            disabledCash: false,
            nickname:'',
            userCode:'',
            cashApplyStatus:'',
            statuses: [],
            statusMap: {},
            dialogVisible: false,
            checkModel: {
                status: 'SUCCESS',
            },
          }
    },
    created() {
        var _this = this;
        _this.statuses = _this.$common.enum_config('ECashApplyStatus');
        console.log(_this.statuses)
        _this.statuses.forEach((item)=>{
            _this.statusMap[item.name] = item.label;
        });
        _this.cashId = _this.$route.query.cashId;
        _this.userInfo = _this.$common.cache('user_info');
        _this.detailCashApplyByManager();
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        detailCashApplyByManager() {
            var _this = this;
            if (_this.cashId) { 
                _this.$common.my_ajax({
                    url: 'cashApply/pageCashApplyByManager',
                    data: {
                        id: _this.cashId
                    },
                    success: function(response) {
                        _this.cashModel = response.items[0];
                        _this.detailMember(_this.cashModel.userId);
                    }
                });
            }
        },
        detailMember(_userId) {
            var _this = this;
            _this.$common.my_ajax({
                url: 'member/findMemberByuserId',
                data: {
                    userId: _userId
                },
                success: function(response) {
                    _this.nickname= response.item.nickname;
                    _this.userCode= response.item.code;
    
                }
            });
        },
        openCheckDialog(_status,_id){
            this.dialogVisible=true;
            this.checkModel.extractId=_id;
            this.checkModel.status=_status;
            this.checkModel.adminUserId=this.userInfo.userId;
        },
        updateBalanceExtractStatus(_status, _id) {
            var _this = this;
            _this.disabledCash = true;
            _this.$common.my_ajax({
                url: 'balanceExtract/updateBalanceExtractStatus',
                data:_this.checkModel,
                success: function(response) {
                    _this.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    _this.$router.push({ name: 'cashList' });
                }
            });
        },
    }
}
</script>
<style scoped>


</style>